(() => {
  const cleanGallery = (gallery) => {
    const reveal = (root) => {
      if (root instanceof Element && root.matches('.hide-media')) root.classList.remove('hide-media');
      root.querySelectorAll?.('.hide-media').forEach((element) => element.classList.remove('hide-media'));
    };

    reveal(gallery);

    if (gallery.dataset.languageSafeMediaFilter === 'true') return;
    gallery.dataset.languageSafeMediaFilter = 'true';

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') reveal(mutation.target);
        for (const node of mutation.addedNodes) reveal(node);
      }
    }).observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  const initialize = (root = document) => {
    if (root instanceof Element && root.matches('media-gallery')) cleanGallery(root);
    root.querySelectorAll?.('media-gallery').forEach(cleanGallery);
  };

  initialize();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) initialize(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
